import AjaxUtils from './ajaxUtils';

export const showContactsByDataPoints = async searchData => await AjaxUtils.post('/api' +
  '/v5/show', searchData);
